import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const UserDashboardTable = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    try {
      const userData = localStorage.getItem('userLogin');
      if (userData) setUser(JSON.parse(userData));
    } catch (error) {
      console.error('Error reading login info:', error);
    }
  }, []);

  return (
    <Wrapper>
      <table>
        <tbody>
          <tr>
            <td>
              <ProfileImage 
                src={user?.picture || '/images/user-icon.png'}  // ✅ Leading slash!
                alt="Profile"
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/images/default-avatar.png';
                }}
                />

            </td>
          </tr>
          <tr className='userdetails'>
            <th>Name</th>
            <td>: {user?.name || user?.username}</td>
          </tr>

          <tr className='userdetails'>
            <th>Email</th>
            <td>: {user?.email}</td>
          </tr>
        </tbody>
      </table>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;

  .userdetails{
    border-bottom: 1px solid black;
  }

    @media(max-width:480px){
    padding: 20px 10px;
    th,td{
        font-size: 9px;
    }}
`;

const ProfileImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
  display: block;
  margin: auto;
  background-color: #ef4766;
  @media(max-width:480px){
    width: 20px;
    height: 20px;
  }
`;

export default UserDashboardTable;
